import { URLS_APP } from '../../../config'

export const CENTRAL_AJUDA = 'https://duvidas.taglivros.com/central-ajuda#collabs'

export const COMUNIDADE_TELEGRAM = 'https://t.me/+iK77swNzLBBlMzQx'

export const INSTAGRAM_CLUBE = '@booksterpelomundo2027'

export const FORMULARIO_INSTAGRAM = 'https://forms.gle/rtpvdBtU2GJMy8pD6'

export const INSTAGRAM_DM_PEDRO = 'https://ig.me/m/booksterpelomundo2026'

export const INSTAGRAM_PERFIL_PEDRO = 'https://www.instagram.com/booksterpelomundo2026'

export const TERMOS_DO_CLUBE = 'https://duvidas.taglivros.com/termos-de-servico-bookster-2027'

export const WHATSAPP_EQUIPE_TAG = 'https://wa.me/555193207593?text=Quero+falar+sobre+minha+renova%C3%A7%C3%A3o+Bookster+pelo+mundo&utm_source=chatgpt.com'

export const { URL_CHECKOUT_BOOKSTER } = URLS_APP
